module.exports = "/css/fonts/nucleo-icons.woff2?426439788ec5ba772cdf94057f6f4659";